import InputMask from "react-input-mask";
import {
  FIELD_ERROR_TEXT_CLASS,
  FIELD_LABEL_CLASS,
  getErrorMessage,
  getFieldClass,
} from "./inputStyles";

const CPFInput = ({
  className,
  error,
  label,
  name,
  value,
  type = "text",
  required,
  register,
  ...props
}) => {
  const errorMessage = getErrorMessage(error);

  return (
    <div className={`w-full ${className || ""}`}>
      {label ? (
        <label className={FIELD_LABEL_CLASS} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <InputMask
        type={type}
        id={name}
        name={name}
        className={getFieldClass(Boolean(error))}
        placeholder="000.000.000-00"
        {...(register && name ? register(name, { required }) : {})}
        mask="999.999.999-99"
        maskChar=""
        alwaysShowMask={false}
        /*
          Mesma proteção que o PhoneInput já tinha: o react-input-mask chama
          `.split()` no `value` dentro do componentDidUpdate, e `null` —
          que é o que o backend devolve para campo vazio — derruba a tela
          inteira com "Cannot read properties of null".

          O spread é condicional para não tornar controlado quem só usa
          `register`: nesse caso o campo pararia de aceitar digitação.
        */
        {...(value !== undefined ? { value: value ?? "" } : {})}
        {...props}
      />
      {errorMessage ? (
        <small className={FIELD_ERROR_TEXT_CLASS}>{errorMessage}</small>
      ) : null}
    </div>
  );
};

export default CPFInput;
